import { render } from "./Feed.vue?vue&type=template&id=034202c4&scoped=true"
import script from "./Feed.vue?vue&type=script&lang=ts"
export * from "./Feed.vue?vue&type=script&lang=ts"

import "./Feed.vue?vue&type=style&index=0&id=034202c4&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-034202c4"

export default script